import React, { Fragment } from "react";
import { Form, Col, Row, Button, InputGroup } from "react-bootstrap";
import { API_URL } from "../../utils/Constants";
import SecureAPI from "../../SecureAPI";
import LoginWrapper from "./LoginWrapper";
import {
  API_AUTH_TOKEN,
  API_CONTEXT_TYPE,
  API_METHOD_POST,
  FORGOT_PASSWORD_CONSTANTS,
  SEND_OTP_LIMIT,
  LOGINPAGE_CONSTANTS,
  FORGOT_PASSWORD_STEPPERS,
  FORGOT_PASSWORD_INITIAL_STATE,
  FORGOT_PASSWORD_INSTRUCTIONS,
  REGEX_VALIDATIONS,
} from "../../config/constants";
import {
  WarningLogo,
  EyeHideLogo,
  EyeOpenLogo,
  PasswordSuccessLogo,
} from "../../assets/icons/index.js";
import { ROUTES } from "../../config/routes";
import { Typography } from "@mui/material";

class ForgotPassword extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSubmitEmailId = this.handleSubmitEmailId.bind(this);
    this.handleEmailId = this.handleEmailId.bind(this);
    this.resetState = this.resetState.bind(this);
    this.handleOtpSubmit = this.handleOtpSubmit.bind(this);
    this.handleOTP = this.handleOTP.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
    this.handlePasswordUpdate = this.handlePasswordUpdate.bind(this);
    this.handlePasswordVisibility = this.handlePasswordVisibility.bind(this);
    this.state = {
      ...FORGOT_PASSWORD_INITIAL_STATE,
    };
  }

  componentWillUnmount() {
    this.setState({
      ...FORGOT_PASSWORD_INITIAL_STATE,
    });
  }

  handlePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPass: !prevState.showPass,
    }));
  };

  handleEmailId = (event) => {
    const newValue = event?.target?.value?.replace(
      REGEX_VALIDATIONS.removeSpace,
      ""
    );
    if (newValue === this.state.adminEmailId) return;
    this.setState({
      adminEmailId: newValue,
      emailFailure: false,
      emailFailureMsg: "",
    });
  };

  handleOTP = (event) => {
    const newValue = event?.target?.value?.replace(
      REGEX_VALIDATIONS.removeSpace,
      ""
    );
    if (newValue.length > 6 || newValue === this.state.otp) return;
    this.setState({
      otp: newValue,
      otpFailure: false,
    });
  };

  handlePassword = (event) => {
    const newValue = event?.target?.value?.replace(
      REGEX_VALIDATIONS.removeSpace,
      ""
    );
    if (newValue === this.state.newPwd) return;
    this.setState({
      newPwd: newValue,
      pwdFailure: false,
      pwdFailureMsg: "",
      match: false,
      emptyfield: false,
    });
  };

  handleConfirmPassword = (event) => {
    const newValue = event?.target?.value?.replace(
      REGEX_VALIDATIONS.removeSpace,
      ""
    );
    if (newValue === this.state.confirmPwd) return;
    this.setState({
      confirmPwd: newValue,
      pwdFailure: false,
      pwdFailureMsg: "",
      match: false,
      emptyfield: false,
    });
  };

  resetState = () => {
    this.setState({
      ...FORGOT_PASSWORD_INITIAL_STATE,
    });
  };

  handleOtpSubmit = (e) => {
    const { otp, otpToken } = this.state;
    e.preventDefault();
    if (otp !== "" && otpToken !== "") {
      let data = {
        otp: otp,
        otpToken: otpToken,
      };
      fetch(API_URL.VERIFY_OTP, {
        method: API_METHOD_POST,
        body: JSON.stringify(data),
        headers: {
          "Content-Type": API_CONTEXT_TYPE,
          "X-Auth-Token": API_AUTH_TOKEN,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          this.setState({
            successCode: response.status.code,
            authCodeOtp: response.body.authorization,
          });
          if (response.status.code === "Y") {
            this.setState({ otpSuccess: true, currentStep: 3, validated: false });
          } else if (response.status.code === "N") {
            this.setState({ otpFailure: true });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({
            otpFailure: true,
            otpFailureMsg: FORGOT_PASSWORD_CONSTANTS.INVALID_OTP,
          });
        });
    }
  };

  handleSubmitEmailId = (e) => {
    e.preventDefault();
    const { adminEmailId } = this.state;
    this.setState({ validated: true });
    if (adminEmailId !== "") {
      let data = {
        emailAddress: adminEmailId,
        phoneEmail: "E",
      };
      fetch(API_URL.FORGOT_PASSWORD, {
        method: API_METHOD_POST,
        body: JSON.stringify(data),
        headers: {
          "Content-Type": API_CONTEXT_TYPE,
          "X-Auth-Token": API_AUTH_TOKEN,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status.code === "Y") {
            this.setState({
              successCodeEmail: response.status.code,
              otpToken: response.body.otpToken,
              mail: response.body.supportNumber,
              validated: false
            });
          } else {
            this.setState({ successCodeEmail: response.status.code });
          }
          if (response.status.code === "Y") {
            this.setState({ emailSuccess: true, currentStep: 2 });
          } else if (response.status.code === "N") {
            if (response.status.errorCode === SEND_OTP_LIMIT) {
              this.setState({ emailFailureMsg: response.status.message });
            }
            this.setState({ emailFailure: true, currentStep: 1 });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({
            emailFailure: true,
            emailFailureMsg: LOGINPAGE_CONSTANTS.INVALID_EMAIL,
          });
        });
    }
  };

  handlePasswordUpdate = async (e) => {
    e.preventDefault();
    const { newPwd, confirmPwd, otpToken, mail, authCodeOtp } = this.state;
    if (newPwd !== "" && confirmPwd !== "" && otpToken !== "" && mail !== "") {
      if (newPwd !== confirmPwd) {
        this.setState({ match: true });
      } else {
        const regexValidation = REGEX_VALIDATIONS.forgotPassword.test(newPwd);
        if (!regexValidation) {
          this.setState({
            pwdFailure: true,
            pwdFailureMsg:
              FORGOT_PASSWORD_CONSTANTS.PASSWORD_VALIDATION_FAILURE,
            emptyfield: false,
            match: false,
          });
          return;
        }
        let api = new SecureAPI();
        let headers = {
          "Content-Type": API_CONTEXT_TYPE,
          "X-Auth-Token": API_AUTH_TOKEN,

          Authorization: authCodeOtp,
        };
        let data = {
          newPassword: newPwd,
          otpToken: otpToken,
        };
        try {
          await api
            .request(API_URL.UPDATE_PASSWORD, "POST", headers, data)
            .then((response) => {
              this.setState({
                successCode: response.status.code,
                updatePwdSuccessMsg: response.status.message,
              });
              if (response.status.code === "Y") {
                this.setState({
                  updatePwdSuccess: true,
                  currentStep: "complete",
                  validated: false
                });
              } else if (response.status.code === "N") {
                this.setState({ updatePwdFailure: true });
              }
            });
        } catch (error) {
          console.error("Error:", error);
          this.setState({
            pwdFailure: true,
            pwdFailureMsg: FORGOT_PASSWORD_CONSTANTS.PASSWORD_UPDATE_FAILURE,
          });
        }
      }
    } else {
      this.setState({ emptyfield: true });
    }
  };

  renderButtons({ onClickProp, disabled, buttonName }) {
    return (
      <Fragment>
        <Form.Group as={Row} className="mb-3">
          <Col sm={16}>
            <Button
              className="login-button"
              onClick={onClickProp}
              disabled={disabled}
            >
              {buttonName}
            </Button>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Col sm={16}>
            <a
              href={ROUTES.LOGIN}
              className="nav-link"
              onClick={this.resetState}
            >
              <Button className="back-button">
                {FORGOT_PASSWORD_CONSTANTS.BACK_BUTTON}
              </Button>
            </a>
          </Col>
        </Form.Group>
      </Fragment>
    );
  }

  renderStepper() {
    const { currentStep } = this.state;
    return (
      <div className="d-flex justify-content-between align-items-center w-100 pb-5">
        {Number(currentStep) ? (
          FORGOT_PASSWORD_STEPPERS.map((step, idx) => {
            return (
              <Fragment key={step.stepId}>
                <Typography
                  key={step.stepId}
                  variant="h5"
                  className={
                    currentStep >= step.stepId ? "step-active" : "step-inactive"
                  }
                >
                  {step.stepId}
                </Typography>
                {idx < FORGOT_PASSWORD_STEPPERS.length - 1 && (
                  <div
                    className={
                      currentStep > step.stepId
                        ? "divider-active"
                        : "divider-inactive"
                    }
                  >
                    {currentStep === step.stepId && (
                      <div className="divider-progress" />
                    )}
                  </div>
                )}
              </Fragment>
            );
          })
        ) : (
          <div className="w-100 d-flex justify-content-center">
            <PasswordSuccessLogo />
          </div>
        )}
      </div>
    );
  }

  renderStep1() {
    const { validated } = this.state;
    return (
      <Fragment>
        <div className="login-header mt-3">
          {FORGOT_PASSWORD_CONSTANTS.STEP1_HEADER}
        </div>
        <div className="login-subheader mt-3">
          {FORGOT_PASSWORD_CONSTANTS.STEP1_SUBHEADER}
        </div>
        <Form validated={validated}>
          <Form.Group
            as={Row}
            className="mt-4 mb-3"
            controlId="formHorizontalEmail"
          >
            <Col sm={16} className="login-section">
              <Form.Floating className="flex-grow-1">
                <Form.Control
                  id="emailVal"
                  value={this.state.adminEmailId}
                  type="email"
                  key="login-email"
                  className="login-text-field"
                  placeholder={LOGINPAGE_CONSTANTS.EMAIL_PLACEHOLDER}
                  onChange={(e) => {
                    this.handleEmailId(e);
                  }}
                  onSelect={(e) => {
                    this.handleEmailId(e);
                  }}
                  required
                />
                <label htmlFor="emailVal">
                  {LOGINPAGE_CONSTANTS.EMAIL_PLACEHOLDER}
                </label>
              </Form.Floating>
              {this.state.emailFailure && (
                <div className="login-email-feedback">
                  <WarningLogo />
                  <span className="text-danger mx-1">
                    {this.state.emailFailureMsg}
                  </span>
                </div>
              )}
            </Col>
          </Form.Group>
          {this.renderButtons({
            onClickProp: this.handleSubmitEmailId,
            disabled: !this.state.adminEmailId,
            buttonName: FORGOT_PASSWORD_CONSTANTS.STEP1_BUTTON,
          })}
        </Form>
      </Fragment>
    );
  }

  renderStep2() {
    const { validated } = this.state;
    return (
      <Fragment>
        <div className="login-header mt-3">
          {FORGOT_PASSWORD_CONSTANTS.STEP2_HEADER}
        </div>
        <div className="login-subheader mt-3">
          {FORGOT_PASSWORD_CONSTANTS.STEP2_SUBHEADER}
        </div>
        <Form validated={validated}>
          <Form.Group
            as={Row}
            className="mt-4 mb-3"
            controlId="formHorizontalOtp"
          >
            <Col sm={16} className="login-section">
              <Form.Floating className="flex-grow-1">
                <Form.Control
                  id="otpVal"
                  value={this.state.otp}
                  type="number"
                  className="login-text-field"
                  placeholder={LOGINPAGE_CONSTANTS.OTP_PLACEHOLDER}
                  onChange={(e) => {
                    this.handleOTP(e);
                  }}
                  onSelect={(e) => {
                    this.handleOTP(e);
                  }}
                  required
                />
                <label htmlFor="otpVal">
                  {LOGINPAGE_CONSTANTS.OTP_PLACEHOLDER}
                </label>
              </Form.Floating>
              {this.state.otpFailure && (
                <div className="login-email-feedback">
                  <WarningLogo />
                  <span className="text-danger mx-1">
                    {this.state.otpFailureMsg}
                  </span>
                </div>
              )}
            </Col>
          </Form.Group>
          {this.renderButtons({
            onClickProp: this.handleOtpSubmit,
            disabled: !this.state.otp || this.state.otp.length !== 6,
            buttonName: FORGOT_PASSWORD_CONSTANTS.STEP2_BUTTON,
          })}
        </Form>
      </Fragment>
    );
  }

  renderStep3() {
    const { validated } = this.state;
    return (
      <Fragment>
        <div className="login-header mt-3">
          {FORGOT_PASSWORD_CONSTANTS.STEP3_HEADER}
        </div>
        <div className="login-subheader mt-3">
          {FORGOT_PASSWORD_CONSTANTS.STEP3_SUBHEADER}
        </div>
        <Form validated={validated}>
          <Form.Group
            as={Row}
            className="mt-4"
            controlId="formHorizontalPassword"
          >
            <Col sm={16} className="login-section">
              <InputGroup className="mb-2">
                <Form.Floating className="flex-grow-1">
                  <Form.Control
                    id="newPwd"
                    value={this.state.newPwd}
                    type={this.state.showPass ? "text" : "password"}
                    className="login-text-field"
                    placeholder={LOGINPAGE_CONSTANTS.CREATE_NEW_PASSWORD}
                    onChange={(e) => {
                      this.handlePassword(e);
                    }}
                    onSelect={(e) => {
                      this.handlePassword(e);
                    }}
                    required
                    isInvalid={
                      this.state.pwdFailure ||
                      this.state.emptyfield ||
                      this.state.match
                    }
                  />
                  <label htmlFor="newPwd">
                    {LOGINPAGE_CONSTANTS.CREATE_NEW_PASSWORD}
                  </label>
                </Form.Floating>
                <InputGroup.Text
                  onClick={this.handlePasswordVisibility}
                  style={{ cursor: "pointer" }}
                >
                  {this.state.showPass ? <EyeHideLogo /> : <EyeOpenLogo />}
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Form.Group>
          <ul className="password-list-group">
            {FORGOT_PASSWORD_INSTRUCTIONS.map((instruction, index) => (
              <li key={instruction} className="password-list-item">
                {instruction}
              </li>
            ))}
          </ul>
          <Form.Group
            as={Row}
            className="mt-4"
            controlId="formHorizontalConfirmPassword"
          >
            <Col sm={16} className="login-section">
              <InputGroup className="mb-4">
                <Form.Floating className="flex-grow-1">
                  <Form.Control
                    id="confirmPwd"
                    value={this.state.confirmPwd}
                    type={this.state.showPass ? "text" : "password"}
                    className="login-text-field"
                    placeholder={LOGINPAGE_CONSTANTS.CONFIRM_NEW_PASSWORD}
                    onChange={(e) => {
                      this.handleConfirmPassword(e);
                    }}
                    onSelect={(e) => {
                      this.handleConfirmPassword(e);
                    }}
                    required
                    isInvalid={
                      this.state.pwdFailure ||
                      this.state.emptyfield ||
                      this.state.match
                    }
                  />
                  <label htmlFor="confirmPwd">
                    {LOGINPAGE_CONSTANTS.CONFIRM_NEW_PASSWORD}
                  </label>
                </Form.Floating>
                <InputGroup.Text
                  onClick={this.handlePasswordVisibility}
                  style={{ cursor: "pointer" }}
                >
                  {this.state.showPass ? <EyeHideLogo /> : <EyeOpenLogo />}
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Form.Group>
          {(this.state.emptyfield ||
            this.state.match ||
            this.state.pwdFailure) && (
              <div className="login-email-feedback mb-4">
                <WarningLogo />
                <span className="text-danger mx-1">
                  {this.state.emptyfield && this.state.emptyFieldMessage}
                  {this.state.match && this.state.matchMessage}
                  {this.state.pwdFailure && this.state.pwdFailureMsg}
                </span>
              </div>
            )}
          {this.renderButtons({
            onClickProp: this.handlePasswordUpdate,
            disabled: !this.state.newPwd || !this.state.confirmPwd,
            buttonName: FORGOT_PASSWORD_CONSTANTS.STEP3_BUTTON,
          })}
        </Form>
      </Fragment>
    );
  }

  renderComplete() {
    return (
      <Fragment>
        <div className="login-header">
          {FORGOT_PASSWORD_CONSTANTS.STEP_COMPLETE_HEADER}
        </div>
        <div className="login-subheader my-3">
          {FORGOT_PASSWORD_CONSTANTS.STEP_COMPLETE_SUBHEADER}
        </div>
        <Col sm={16}>
          <a href={ROUTES.LOGIN} className="nav-link" onClick={this.resetState}>
            <Button className="login-button">
              {FORGOT_PASSWORD_CONSTANTS.BACK_BUTTON}
            </Button>
          </a>
        </Col>
      </Fragment>
    );
  }

  render() {
    return (
      <LoginWrapper>
        <div className="login-container">
          {this.renderStepper()}
          {this.state.currentStep === 1 && this.renderStep1()}
          {this.state.currentStep === 2 && this.renderStep2()}
          {this.state.currentStep === 3 && this.renderStep3()}
          {this.state.currentStep === "complete" && this.renderComplete()}
        </div>
      </LoginWrapper>
    );
  }
}

export default ForgotPassword;
